import * as types from './types';

const clearSaveState = () => ({
  type: types.SAVE_POSTING_DB_CLEAR
});

const setSaveSource = triggerSource => ({
  type: types.SAVE_POSTING_SET_SAVE_SOURCE,
  payload: {
    triggerSource
  }
});

const savePostingDB = payload => ({
  type: types.SAVE_POSTING_DB,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorProf',
    path: `/publication/api/v1/posting/${payload.step}`,
    body: payload.body,
    method: 'POST'
  }
});

const setLoading = loading => ({
  type: types.SET_LOADING,
  payload: { loading }
});

export { savePostingDB, clearSaveState, setSaveSource, setLoading };
